import type { Converter } from '../types';

export function formulaConvert(
  c: Converter,
  value: number,
  fromUnit: string,
  toUnit: string,
  conditions: Record<string, number>
): number {
  const isReversed = fromUnit !== c.primaryInput && toUnit === c.primaryInput;
  const expr = (isReversed && (c as any).reverseFormulaJs) ? (c as any).reverseFormulaJs : c.formulaJs;
  if (!expr) throw new Error('No formulaJs defined for this converter');

  const allowed = new Set(['v', 'Math']);
  if (c.conditions) c.conditions.forEach(cond => allowed.add(cond.key));

  const fn = new Function(
    ...allowed,
    `"use strict"; return (${expr});`
  );

  const args: Record<string, unknown> = { v: value, Math };
  for (const cond of c.conditions ?? []) {
    args[cond.key] = conditions[cond.key] ?? cond.default;
  }

  return Number(fn(...Object.values(args)));
}
